/**
 * block spec
 *
 * _id : String // Created client side
 * root : Boolean // Indicates whether a block is root block or not. Defaults to false. Ideally in the future there can be more than 1 root block
 * parent : String // _id of the parent block
 * type : String // Type of block. Can be 'text' or 'folder' at the moment
 * owner : String // _id of the user who created the block. We're not checking this atm because it is offline only
 * archive : Boolean // Indicates whether a block is removed or not. Not being used currently. Defaults to false NOT IMPLEMENTED
 * blocks : Array // Array of blocks. Contains block._id s of child blocks. Defaults to an empty array
 * content : Object // Object containing freeform content in keys such as title, html, etc
 * fields : Array // Array containing quantative data. Not being used yet NOT IMPLEMENTED
 * source : Object // Object containing source of the current block. Use keys like url, authorName, authorUrl, authorTwitter, etc to indicate more source data
 * createdAt : Date // Date object. Only set when created
 * updatedAt : Date // Date object. Only set when updated
 */

import nanoid from 'nanoid';

export default {
	createBlock: function(obj, userId) {
		let block = {
			_id: obj._id || nanoid(),
			owner: obj.owner || userId || '',
			type: obj.type || 'text',
			root: obj.root || false,
			parent: obj.parent || '',
			archive: false,
			blocks: obj.blocks || [],
			content: obj.content || {},
			properties: obj.properties || {},
			fields: [],
			createdAt: obj.createdAt || new Date(),
			updatedAt: obj.updatedAt || ''
		};
		return block;
	}
};
